module.exports = __webpack_public_path__ + "img/pjt-logo-3.2b38379b.png";